import { ICodeNameDto } from "../../../interface/dto/code-name.dto";
import { IRootState } from "../../../redux/root.reducer";
import { createIGSERedux } from "../../../shared/igse-redux/igse-redux-factory";
import { selectAuthTokens } from "../../auth/selectors/auth.selector";
import { getSICCodes } from "../service/sic-codes.api";

const {
    actions: sicCodesActions,
    reducer: sicCodesReducer,
    epic: sicCodesEpic,
} = createIGSERedux<Array<ICodeNameDto>>({
    actionNames: {
        init: "SIC_CODES_INIT",
        get: "SIC_CODES_GET",
        success: "SIC_CODES_SUCCESS",
        error: "SIC_CODES_ERROR",
    },
    fetcher: () => getSICCodes(selectAuthTokens()),
    selector: (state: IRootState) => state.sicCodes,
});

export { sicCodesActions, sicCodesReducer, sicCodesEpic };
